var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBlueGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-blue-gradient"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "28.48%",
    stopColor: "#1ab2d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "141.74%",
    stopColor: "#0078ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlueGradient);
export default __webpack_public_path__ + "static/media/IconBlueGradient.c64577ceeded735d6adac3764b0825bf.svg";
export { ForwardRef as ReactComponent };